var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashUat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlashUat_svg__a",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 10.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 10.667,
    fill: "#E74536"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "FlashUat_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlashUat_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlashUat_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#0F1941",
    cx: 33.917,
    cy: 28,
    r: 24.667
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7F5F0",
    cx: 29.917,
    cy: 24.667,
    r: 24.667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31.25h64v19H0z",
    fill: "#6BA5B4"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Graphik-Regular, Graphik",
    fontSize: 16.5,
    letterSpacing: -0.75,
    fill: "#FFF",
    transform: "translate(0 30.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31.831,
    y: 13
  }, "UAT")), /*#__PURE__*/React.createElement("path", {
    d: "M37.872 21.958h-3.368l3.784-18.071c.355-1.693-1.928-2.618-2.884-1.17L19.906 26.184c-.687 1.04.07 2.418 1.33 2.418h2.68L18.678 42.76c-.543 1.469 1.378 2.591 2.425 1.417l17.802-19.968c.781-.876.15-2.25-1.033-2.25z",
    fill: "#FFB511"
  }))))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPGRlZnM+CiAgICAgICAgPHJlY3QgaWQ9ImEiIHg9IjAiIHk9IjAiIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgcng9IjEwLjY2NyIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cmVjdCB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHJ4PSIxMC42NjciIGZpbGw9IiNFNzQ1MzYiLz4KICAgICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8L21hc2s+CiAgICAgICAgPGcgbWFzaz0idXJsKCNiKSI+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNS43NSkiPgogICAgICAgICAgICAgICAgPGNpcmNsZSBmaWxsPSIjMEYxOTQxIiBjeD0iMzMuOTE3IiBjeT0iMjgiIHI9IjI0LjY2NyIvPgogICAgICAgICAgICAgICAgPGNpcmNsZSBmaWxsPSIjRjdGNUYwIiBjeD0iMjkuOTE3IiBjeT0iMjQuNjY3IiByPSIyNC42NjciLz4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wIDMxLjI1aDY0djE5SDB6IiBmaWxsPSIjNkJBNUI0Ii8+CiAgICAgICAgICAgICAgICA8dGV4dCBmb250LWZhbWlseT0iR3JhcGhpay1SZWd1bGFyLCBHcmFwaGlrIiBmb250LXNpemU9IjE2LjUiIGxldHRlci1zcGFjaW5nPSItLjc1IiBmaWxsPSIjRkZGIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDMwLjc1KSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjMxLjgzMSIgeT0iMTMiPlVBVDwvdHNwYW4+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMzcuODcyIDIxLjk1OGgtMy4zNjhsMy43ODQtMTguMDcxYy4zNTUtMS42OTMtMS45MjgtMi42MTgtMi44ODQtMS4xN0wxOS45MDYgMjYuMTg0Yy0uNjg3IDEuMDQuMDcgMi40MTggMS4zMyAyLjQxOGgyLjY4TDE4LjY3OCA0Mi43NmMtLjU0MyAxLjQ2OSAxLjM3OCAyLjU5MSAyLjQyNSAxLjQxN2wxNy44MDItMTkuOTY4Yy43ODEtLjg3Ni4xNS0yLjI1LTEuMDMzLTIuMjV6IiBmaWxsPSIjRkZCNTExIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgFlashUat as ReactComponent };